export const violationFields = [
    { key: 'violationId', label: 'Violation ID' },
    { key: 'inspectionId', label: 'Inspection ID' },
    { key: 'deviceId', label: 'Device ID' },
    { key: 'violationDate', label: 'Violation Date' },
    { key: 'violationStatus', label: 'Violation Status' },
    { key: 'notes', label: 'Notes' },
    { key: 'devicePart', label: 'Device Part' },
    { key: 'violatingCondition', label: 'Violating Condition' },
    { key: 'suggestedRemedy', label: 'Suggested Remedy' },
];

export const inspectionFields = [
    { key: 'inspectionId', label: 'Inspection ID' },
    { key: 'deviceId', label: 'Device ID' },
    { key: 'test', label: 'Test' },
    { key: 'taskType', label: 'Task Type' },
    { key: 'approvalDate', label: 'Approval Date' },
    { key: 'nextDate', label: 'Next Date' },
    { key: 'lastDate', label: 'Last Date' },
];